export default build =>
    build.mutation({
        query(payload) {
            return {
                url: `/exam/getConsolidatedReport`,
                method: 'POST',
                body: payload,
            };
        },
    })
